module.exports = "/static/assets/74a059c43e52a614bb6d873cd3a817b5.gif";